var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"navbar"}}),_c('router-view',{staticClass:"main",class:{'logged-in': _vm.user.id && !_vm.hide_navbar, 'dark-mode': _vm.dark_mode}}),_c('vue-progress-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }